import { memo, PropsWithChildren } from "react";

import styled from "styled-components";

import Paper from "@mui/material/Paper";

import LogoIcon from "../../../../layouts/components/Icon/Logo";

import { classIf } from "utility/style";

// -----------------------------------------------------------------------------

export const LoginContainer = memo(function LoginPageContainer({
  children,
  noMaxWidth,
}: Props): JSX.Element {
  return (
    <Container elevation={1} className={classIf(!noMaxWidth, "maxWidth")}>
      <Logo />
      {children}
    </Container>
  );
});

// -----------------------------------------------------------------------------

const Container = styled(Paper)`
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 16px;
  position: relative;

  &.maxWidth {
    max-width: 420px;
    width: 100%;
  }
`;

const Logo = styled(LogoIcon)`
  position: absolute;
  left: 50%;
  bottom: 100%;
  margin-bottom: 16px;
  transform: translateX(-50%);

  fill: #fff;
  width: 164.17px;
  height: 40px;
`;

// -----------------------------------------------------------------------------

interface Props extends PropsWithChildren {
  noMaxWidth?: boolean;
}
